// extracted by mini-css-extract-plugin
var _1 = "TableCellText-moduleTableCellText__b5epO";
var _2 = "TableCellText-moduletextContainer__XYKMQ";
export { _1 as "TableCellText", _2 as "textContainer" }
